import React from 'react'

function Callout({error}) {
  return error?<div className="pt-callout pt-intent-danger">Error: {error.message}</div>:null
}

export default Callout



/** WEBPACK FOOTER **
 ** ./client/components/blueprint/Callout.js
 **/